import React, { Component } from "react";
import { Desktop } from "../containers/common";
import { Switch, Route, useRouteMatch } from "react-router-dom";

//screens
import { LoyaltyHome, LoyaltyDescription } from "../screens/subscriber/loyalty";
import { LiveStream, LiveStreamHome } from "../screens/subscriber/liveStream";
import {
  MovieManiaVotingHome,
  MovieDescription,
  MovieManiaTicketGeneration,
} from "../screens/subscriber/movieMania";
import { MovieManiaRedemptionHome } from "../screens/subscriber/movieManiaRedemption";
import { DishrackHome } from "../screens/subscriber/dishrack";
import { DishrackRedemptionHome } from "../screens/subscriber/dishrackRedemption";
import { PotbellyHome } from "../screens/subscriber/potbelly";
import { PotbellyRedemptionHome } from "../screens/subscriber/potbellyRedemption";
import ViewAllEvents from "../screens/subscriber/event/ViewAllEvents";
import ViewAllOffers from "../screens/subscriber/loyalty/ViewAllOffers";
import { GamesAll } from "../screens/subscriber/loyalty";
import BlackFriday from "../screens/subscriber/blackFriday/BlackFriday";
import { Announcement } from "../screens/subscriber/announcement";

const Loyalty = () => {
  const match = useRouteMatch();
  return (
    <Desktop phonebg={"white"}>
      <Switch>
        <Route
          path={`${match.path}/loyaltydescription`}
          render={() => <LoyaltyDescription />}
        />
        <Route
          path={`${match.path}/moviemania/vote/:id`}
          render={() => <MovieDescription />}
        />
        <Route
          path={`${match.path}/moviemania/ticketgeneration/:id`}
          render={() => <MovieManiaTicketGeneration />}
        />
        <Route
          path={`${match.path}/moviemania`}
          render={() => <MovieManiaVotingHome />}
        />
        <Route
          path={`${match.path}/dishrack`}
          render={() => <DishrackHome />}
        />
        <Route
          path={`${match.path}/moviemaniaredemption`}
          render={() => <MovieManiaRedemptionHome />}
        />
        <Route
          path={`${match.path}/dishrackredemption`}
          render={() => <DishrackRedemptionHome />}
        />
        <Route
          path={`${match.path}/potbelly`}
          render={() => <PotbellyHome />}
        />
        <Route
          path={`${match.path}/potbellyredemption`}
          render={() => <PotbellyRedemptionHome />}
        />
        <Route
          path={`${match.path}/eventshome`}
          render={() => <LiveStreamHome />}
        />
        <Route
          path={`${match.path}/livestream`}
          render={() => <LiveStream />}
        />
        <Route
          path={`${match.path}/announcement`}
          render={() => <Announcement />}
        />
        <Route
          path={`${match.path}/blackFriday`}
          render={() => <BlackFriday />}
        />
        <Route path={`${match.path}/events`} render={() => <ViewAllEvents />} />
        <Route path={`${match.path}/offers`} render={() => <ViewAllOffers />} />
        <Route path={`${match.path}/games`} render={() => <GamesAll />} />
        <Route path={`${match.path}`} render={() => <LoyaltyHome />} />
      </Switch>
    </Desktop>
  );
};

export default Loyalty;
